/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-09 09:49:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 11:30:07
 */
export default {
	"automatedRules.manageRules.blank.message":
		"你还没有创建自动化规则。你可以创建自动化规则，以便在选定的广告系列、广告组或广告满足特定条件时自动调整其设置",

	"automatedRules.manageRules.blank.button": "创建新规则",

	"automatedRules.manageRules.title": "规则管理",
	"automatedRules.manageRules.tip": "Facebook平台可能会存在一定程度的延迟关闭或延迟结算情况",
	"automatedRules.manageRules.search.text": "搜索规则名",
	"automatedRules.manageRules.filter.text": "筛选广告账户",
	"automatedRules.manageRules.limit.text": "可创建的规则：",
	"automatedRules.manageRules.createRule": "创建规则",
	"automatedRules.manageRules.table.column1": "名称",
	"automatedRules.manageRules.table.column2": "操作",
	"automatedRules.manageRules.table.delete.confirm.title": "删除规则",
	"automatedRules.manageRules.table.delete.confirm.content": "如果删除此自动规则，它将不会再次运行。您确定您要删除吗？",

	"automatedRules.rulesMarket.title": "规则市场",
	"automatedRules.rulesMarket.table.column1": "名称",
	"automatedRules.rulesMarket.table.column2": "操作",
	"automatedRules.manageRules.table.delete": "删除",
	"automatedRules.manageRules.table.edit": "编辑",
	"automatedRules.manageRules.table.share": "分享",
	"automatedRules.manageRules.table.copy": "复制",

	"automatedRules.actionHistory.title": "运行历史",
	"automatedRules.actionHistory.search.text": "输入规则名称搜索",
	"automatedRules.actionHistory.filter.text": "输入广告账号搜索",
	"automatedRules.actionHistory.table.column1": "账户名称",
	"automatedRules.actionHistory.table.column2": "规则名称",
	"automatedRules.actionHistory.table.column3": "规则动作",
	"automatedRules.actionHistory.table.column4": "生效维度",
	"automatedRules.actionHistory.table.column5": "生效维度ID",
	"automatedRules.actionHistory.table.column6": "执行时间",

	"automatedRules.actionHistory.table.column7": "报表时间周期",
	"automatedRules.actionHistory.table.column8.tooltip":
		"自动规则将使用您选择的时间周期里的报表累计数据（报表时区为注册的账户时区）",

	"automatedRules.actionHistory.table.column1.placeholder": "请输入广告账户搜索",
	"automatedRules.actionHistory.table.column2.placeholder": "请输入规则名称搜索",
	"automatedRules.actionHistory.table.column3.placeholder": "请选择执行动作",
	"automatedRules.actionHistory.table.column4.placeholder": "请选择生效维度",
	"automatedRules.actionHistory.table.column5.placeholder": "请输入生效维度ID",
	"automatedRules.actionHistory.table.column6.placeholder": "请选择开始时间",
	"automatedRules.actionHistory.table.column7.placeholder": "请选择结束时间",

	"automatedRules.editStrategy.strategyName.label": "规则名称",
	"automatedRules.editStrategy.strategyName.placeholder": "请输入规则名称",
	"automatedRules.editStrategy.adv.desc": "选择最多 {{count}} 个您要管理的广告账户",
	"automatedRules.editStrategy.adv.label": "广告账号",
	"automatedRules.editStrategy.latitude.label": "生效维度",
	"automatedRules.editStrategy.latitude.camapign": "广告系列",
	"automatedRules.editStrategy.latitude.adgroup": "广告组",
	"automatedRules.editStrategy.latitude.ad": "广告",
	"automatedRules.editStrategy.apply rule to": "生效范围",
	"automatedRules.editStrategy.Active": "投放中",
	"automatedRules.editStrategy.Inactive": "已暂停",
	"automatedRules.editStrategy.timeRange": "生效时段",
	"automatedRules.editStrategy.timeRange.toolTip": "规则将在此时段生效（时区为广告账户时区）",
	"automatedRules.editStrategy.repeat": "重复生效",
	"automatedRules.editStrategy.repeat.all time": "重复",

	"automatedRules.strategy.reportPeriod.today": "当天",
	"automatedRules.strategy.reportPeriod.last two days": "过去2天，包括今天",
	"automatedRules.strategy.reportPeriod.last three days": "过去3天，包括今天",
	"automatedRules.strategy.reportPeriod.last seven days": "过去7天，包括今天",
	"automatedRules.strategy.reportPeriod.last two weeks": "过去14天，包括今天",
	// "automatedRules.strategy.reportPeriod.Advertising period": "广告投放期",
	"automatedRules.strategy.reportPeriod.last 28 days": "过去28天，包括今天",
	"automatedRules.strategy.reportPeriod.last 30 days": "过去30天，包括今天",

	"automatedRules.editStrategy.repeat.once": "执行一次",
	"automatedRules.editStrategy.run.schedule.label": "执行频率",
	"automatedRules.editStrategy.run.schedule.value": "每{{minuts}}分钟执行一次",

	"automatedRules.editStrategy.condition": "规则",
	"automatedRules.editStrategy.action": "动作",
	"automatedRules.editStrategy.action.message": "请输入数值",
	"automatedRules.batch.binding.strtegy.bulk operation": "批量操作：",
	"automatedRules.batch.binding.strtegy.bulk operation.item": "批量绑定广告账户",

	"automatedRules.account.bingding.strtegy.binging.state": "是否绑定",
	"automatedRules.account.bingding.strtegy.binging.enable.state": "规则开启状态",
	"automatedRules.account.bingding.strtegy.binging.tip": "开启开关/关闭开关以对该广告账户下的规则进行新增绑定/移除绑定"
};
